<app-layout>
  <app-voltar route="listagem/servico" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          label="Descrição do serviço"
          placeholder="Digite aqui"
          name="TX_TIPO_SRVC"
          maxLength="50"
          formControlName="TX_TIPO_SRVC"
          [requiredInput]="true"
          [disabled]="title.includes('Visualizar') ? true : false"></app-input>
        <app-input
          type="select"
          label="Pode ser apresentado no cadastro do agendamento?"
          name="FL_AGND"
          formControlName="FL_AGND"
          [selectData]="servicoOptions"
          [requiredInput]="true"
          (ngModelChange)="onSelectChange($event, 'FL_AGND')"
          [disabled]="title.includes('Visualizar') ? true : false"></app-input>
        <app-input
          type="select"
          label="Tipo de carga compõe a tabela de preço?"
          name="FL_CRGA"
          formControlName="FL_CRGA"
          [selectData]="servicoOptions"
          [requiredInput]="true"
          (ngModelChange)="onSelectChange($event, 'FL_CRGA')"
          [disabled]="title.includes('Visualizar') ? true : false"></app-input>
        <app-input
          type="select"
          label="Quantidade de compartimento compõe a tabela de preço?"
          name="FL_CPTM"
          formControlName="FL_CPTM"
          [selectData]="servicoOptions"
          [requiredInput]="true"
          (ngModelChange)="onSelectChange($event, 'FL_CPTM')"
          [disabled]="title.includes('Visualizar') ? true : false"></app-input>
        <app-input
          type="select"
          label="Total de eixos compõe a tabela de preço?"
          name="FL_TOTL_EIXO"
          formControlName="FL_TOTL_EIXO"
          [selectData]="servicoOptions"
          [requiredInput]="true"
          (ngModelChange)="onSelectChange($event, 'FL_TOTL_EIXO')"
          [disabled]="title.includes('Visualizar') ? true : false"></app-input>
        <app-input
          type="select"
          label="Tipo de carreta compõe a tabela de preço?"
          name="FL_TIPO_CRRT"
          formControlName="FL_TIPO_CRRT"
          [selectData]="servicoOptions"
          [requiredInput]="true"
          (ngModelChange)="onSelectChange($event, 'FL_TIPO_CRRT')"
          [disabled]="title.includes('Visualizar') ? true : false"></app-input>
        <app-input
          type="dropdown"
          label="Caixa"
          name="NU_CAIX_SRVC"
          formControlName="NU_CAIX_SRVC"
          [selectData]="caixaOptions"
          [requiredInput]="true"
          [coerceValue]="'number'"
          (ngModelChange)="onSelectChange($event, 'NU_CAIX_SRVC')"
          [disabled]="title.includes('Visualizar') ? true : false"></app-input>
        <app-input
          type="dropdown"
          label="Evento"
          name="NU_EVNT_SRVC"
          formControlName="NU_EVNT_SRVC"
          [selectData]="eventoOptions"
          [requiredInput]="form.controls['NU_CAIX_SRVC'].value == 2"
          [coerceValue]="'number'"
          (ngModelChange)="onSelectChange($event, 'NU_EVNT_SRVC')"
          [disabled]="form.controls['NU_EVNT_SRVC'].disabled || title.includes('Visualizar') ? true : false"></app-input>
      </div>
      <app-botao
        type="cadastro"
        class="botao-cadastro"
        *ngIf="!disabledServico"
        [text]="isEditing ? 'Editar Serviço' : 'Cadastrar Serviço'"
        (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
